import { useState } from 'react';
import { FiX, FiEdit3, FiFeather, FiLink } from 'react-icons/fi';

/**
 * Toolbar flotante para acciones sobre versículos seleccionados
 * Se muestra cuando hay versículos seleccionados
 * Compatible con móvil y escritorio
 */
const BibleVerseToolbar = ({
  selectedCount = 0,
  reference = '',
  onAddNote,
  onAddHighlight,
  onAddRelation,
  onCancel
}) => {
  const [showColorPicker, setShowColorPicker] = useState(false);

  const handleHighlight = (color) => {
    if (onAddHighlight) {
      onAddHighlight(color);
      setShowColorPicker(false);
    }
  };

  // Colores disponibles para subrayado
  const highlightColors = [
    { name: 'Amarillo', value: '#fef08a', textColor: '#854d0e' },
    { name: 'Verde', value: '#bbf7d0', textColor: '#14532d' },
    { name: 'Azul', value: '#bfdbfe', textColor: '#1e3a8a' },
    { name: 'Rosa', value: '#fbcfe8', textColor: '#831843' },
    { name: 'Naranja', value: '#fed7aa', textColor: '#7c2d12' },
    { name: 'Morado', value: '#e9d5ff', textColor: '#581c87' },
  ];

  const handleHighlightClick = () => {
    setShowColorPicker(!showColorPicker);
  };

  const handleColorSelect = (color) => {
    // Pasar el valor del color (string hex) en lugar del objeto completo
    onAddHighlight(color.value);
    setShowColorPicker(false);
  };

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 animate-slideUp">
      <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 p-4 min-w-[320px]">
        {/* Header */}
        <div className="flex items-center justify-between mb-4 pb-3 border-b border-gray-200">
          <div>
            <p className="text-sm font-semibold text-gray-900">
              {selectedCount} versículo{selectedCount > 1 ? 's' : ''} seleccionado{selectedCount > 1 ? 's' : ''}
            </p>
            <p className="text-xs text-gray-500 mt-1">{reference}</p>
          </div>
          <button
            onClick={onCancel}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="Cancelar"
          >
            <FiX className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Botones de acción */}
        <div className="grid grid-cols-3 gap-2">
          {/* Agregar Nota */}
          <button
            onClick={onAddNote}
            className="flex flex-col items-center gap-2 p-3 hover:bg-blue-50 rounded-xl transition-colors group"
          >
            <FiEdit3 className="w-6 h-6 text-blue-600 group-hover:scale-110 transition-transform" />
            <span className="text-sm font-medium text-gray-700">Nota</span>
          </button>

          {/* Subrayar (con selector de color) */}
          <div className="relative">
            <button
              onClick={handleHighlightClick}
              className="w-full flex flex-col items-center gap-2 p-3 hover:bg-yellow-50 rounded-xl transition-colors group"
            >
              <FiFeather className="w-6 h-6 text-yellow-600 group-hover:scale-110 transition-transform" />
              <span className="text-sm font-medium text-gray-700">Subrayar</span>
            </button>

            {/* Selector de colores */}
            {showColorPicker && (
              <div className="absolute bottom-full left-0 mb-2 bg-white rounded-xl shadow-xl border border-gray-200 p-3 min-w-[200px] z-10">
                <p className="text-xs font-semibold text-gray-700 mb-2">Elige un color:</p>
                <div className="grid grid-cols-3 gap-2">
                  {highlightColors.map((color) => (
                    <button
                      key={color.value}
                      onClick={() => handleColorSelect(color)}
                      className="h-10 rounded-lg border-2 border-transparent hover:border-gray-400 transition-all hover:scale-105"
                      style={{ backgroundColor: color.value }}
                      title={color.name}
                    >
                      <span className="sr-only">{color.name}</span>
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Agregar Relación */}
          <button
            onClick={onAddRelation}
            className="flex flex-col items-center gap-2 p-3 hover:bg-purple-50 rounded-xl transition-colors group"
          >
            <FiLink className="w-6 h-6 text-purple-600 group-hover:scale-110 transition-transform" />
            <span className="text-sm font-medium text-gray-700">Relacionar</span>
          </button>
        </div>

        {/* Indicador de almacenamiento local */}
        <div className="mt-3 pt-3 border-t border-gray-200">
          <p className="text-xs text-gray-500 text-center flex items-center justify-center gap-1">
            <span className="inline-block w-2 h-2 bg-purple-500 rounded-full"></span>
            Guardado localmente en tu dispositivo
          </p>
        </div>
      </div>

      {/* Estilos de animación */}
      <style jsx>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translate(-50%, 20px);
          }
          to {
            opacity: 1;
            transform: translate(-50%, 0);
          }
        }
        
        .animate-slideUp {
          animation: slideUp 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default BibleVerseToolbar;


